import type {CreatePaymentWayRequest} from '@rocket-ui/lk-api';
import type {SelectedBank} from './selectedBank';
import {formatSbpPhoneForApi} from './sbpPhone';

type BuildSbpPaymentWayParams = {
	phone: string;
	selectedBank: SelectedBank | null;
	isPrimary?: boolean;
};

export function buildSbpPaymentWayRequest({
	phone,
	selectedBank,
	isPrimary = false,
}: BuildSbpPaymentWayParams): CreatePaymentWayRequest | null {
	const bik = selectedBank?.bik?.trim();
	const resolvedPhone = formatSbpPhoneForApi(phone);

	if (!bik || !resolvedPhone) {
		return null;
	}

	return {
		type: 'sbp_account',
		bik,
		phone: resolvedPhone,
		isPrimary,
	};
}
